import Vue from 'vue'
import App from './App.vue';
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import func from '@/script/func';
import store from './store';
import lang from "@/langs/index";
import '@/assets/com.scss';
import Api from '@/script/api';
import { installChatMessageRecvBridge } from '@/script/chatMessageRecvBridge';
import { installShopAuthRecvBridge } from '@/script/shopAuthRecvBridge';
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$func = func;
Vue.prototype.$t = lang;
Vue.prototype.$api = Api;
window.$func = func;
if (window.ELECTRONAPI) {
  Vue.prototype.$eapi = window.ELECTRONAPI
} else {
  Vue.prototype.$eapi = { invoke: () => { return { code: -100, msg: "环境异常", then: (cb) => {cb({code:-100, msg: "环境异常"})} } }, bindBy: () => { },getPreload:()=>{} };
}
window.vue = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

const _eapi = window.ELECTRONAPI || window.vue.$eapi;
if (_eapi && typeof _eapi.bindBy === 'function') {
  installChatMessageRecvBridge(_eapi, store);
  installShopAuthRecvBridge(_eapi);
}
